<button
	mat-stroked-button
	class="bp-round-button bp-button-md"
	type="button"
	color="primary"
	[disabled]="(uploadProgress$ | async) !== null"
>
	<mat-progress-bar
		*ngIf="uploadProgress$ | async as progress"
		@slide
		color="accent"
		mode="determinate"
		[value]="progress"
	>
	</mat-progress-bar>
	<ng-content></ng-content>
</button>

<div
	*ngIf="(uploadedDownloadUrl$ | async) || value as url"
	@fade
	class="thumbnail"
	[style.background-image]="'url(' + url + ')' | safe: 'style'"
></div>

<div *ngIf="(uploadError$ | async) || isExceededAllowedSize" @slide class="error">
	{{ uploadError$ | async }}
	<span *ngIf="isExceededAllowedSize">The maximum allowed size of the file is 15mb</span>
</div>

<input #filePicker type="file" accept=".png,.jpg,.svg,.webp" [disabled]="(canUpload$ | async) === false" />
